import styled from 'styled-components';

export const LayoutContainer = styled.div`
  position: absolute;
  top: ${(p) => p.theme.sizes.header_height};
  left: 0;
  right: 0;
`;
